// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2dgAL","col":"styles_col__10k6y"};